// login component
import { useContext, useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import StateContext from '../stateContext';
import axios from 'axios';

function Login() {
  const navigate = useNavigate();

  // get passed param/page
  const { loginParam, firstParam, secondParam } = useParams();
  const { validUserCreds, setUserInfo, createNotification } = useContext(StateContext);
  const [ initialNotification, setInitialNotification ] = useState(false);

  // check if user is already logged in
  if (validUserCreds() == true) {
    navigate("/home");
  }

  useEffect(() => {
    if(initialNotification != true) {
      setInitialNotification(true);

      if(loginParam == "userCreated") {

        createNotification({
          "status": "success",
          "msg": "Account Verification Needed: Please check the associated email.",
        })
      } else if (loginParam == "passwordResetRequest") {

        createNotification({
          "status": "success",
          "msg": "If a related account exists, a password reset email will be sent to it. Please check the associated email address.",
        })
      } else if (loginParam == "passwordResetSuccess") {

        createNotification({
          "status": "success",
          "msg": "Password Reset Successful!.",
        })
      } else if(loginParam == "accountVerification") {
        if (firstParam === undefined || secondParam === undefined) {
          createNotification({
            "status": "error",
            "msg": "Error verifying account.",
          })

        } else {

          axios.defaults.xsrfCookieName = 'csrftoken';
          axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
          axios.defaults.withCredentials = true;

          axios.post(
            '/api/account/verify',
            {
              "userID": firstParam,
              "verificationID": secondParam
            }
          ).then((response) => {
            if (response.data.success == true && response.data.results > 0) {
              createNotification({
                "status": "success",
                "msg": "Account Verification Successful.",
              })
            } else {

              // notify failure
              createNotification({
                  "status": "error",
                  "msg": "Verification ID failure",
                })
            }
          })
        }
      }
    }
  }, []);

  async function login(event) {
    // prevent default
    event.preventDefault();

    // get form data
    const formData = new FormData(event.target);
    const dataObject = Object.fromEntries(formData.entries());

    // encode password
    dataObject.password = btoa(unescape(encodeURIComponent(dataObject.password.trim())))

    axios.defaults.xsrfCookieName = 'csrftoken';
    axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
    axios.defaults.withCredentials = true;

    axios.post(
      '/api/account/login',
      dataObject
    ).then((response) => {
      if (response.data.success == true && response.data.results > 0) {

        var newUserInfo = {
          "email": dataObject.email,
          "jwt": response.data.result.jwt,
          "fullname_initials": response.data.result.fullname_initials,
          "account_type": response.data.result.account_type,
          "jwt_expiration": response.data.result.jwt_expiration,
          "subscription_status": response.data.result.subscription_status,
          "default_resume_format": response.data.result.default_resume_format
        }

        if (dataObject.keep_logged_in) {
          newUserInfo["keep_logged_in"] = true
        }

        // set new user info
        setUserInfo(newUserInfo);

        // redirect user to home page
        navigate("/home");
      } else if (response.data.result.account_verification_needed == true) {
        createNotification({
          "status": "error",
          "msg": "Account Verification needed...Please check your email.",
        })
      } else {
        // unset user info
        setUserInfo({});

        // notify failure
        createNotification({
          "status": "error",
          "msg": "Login Failed",
        })
      }
    })
  }

  return (
    <>
      <form 
        onSubmit={login} 
        className='floatingContainer'
        style={{
            display: "flex", flexDirection: "column", justifyContent: "center", 
            alignContent: "center", padding: "30px", gap: "15px",
            width: "80%", maxWidth: "400px", minWidth: "300px", margin: "auto",
            borderRadius: "10px", backgroundColor: "#ffffff"
          }}>
        <h1 style={{wordSpacing: "-5px"}}>Work Guild<span style={{fontSize: "20px"}}>.io</span></h1>
        <div className='input'>
          <label htmlFor="email" className="inputLabel">Email</label>
          <input name='email' id='email' autoComplete="off" type='text' placeholder='Enter your email' required/>
        </div>
        <div className='input'>
          <label htmlFor="password" className="inputLabel">Password</label>
          <input name='password' id="password" type='password' placeholder='Enter your password' required/>
        </div>
        <label style={{ fontWeight: "bold", fontSize: "14px"}}>
          Keep Logged In 
          <input type="checkbox" name="keep_logged_in" style={{height: "10px"}}/>
        </label>
        <button type="submit" className='submit'>Login</button>
        <Link to="/forgotPassword" style={{fontWeight: "bold", textAlign: "center", fontSize: "14px", color: "#1e4ad7"}}>Forgot Password?</Link>
        <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
          <hr style={{width: "40%"}}/>
          <span>or</span>
          <hr style={{width: "40%"}}/>
        </div>
        <Link to="/signup" style={{fontWeight: "bold", textAlign: "center", fontSize: "14px"}}>Don't have an account? <span >Sign Up</span></Link>
      </form>
    </>
  )
}

export default Login;